/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LightsRouteImport } from './routes/lights'
import { Route as EventsRouteImport } from './routes/events'
import { Route as CameraRouteImport } from './routes/$camera'
import { Route as IndexRouteImport } from './routes/index'

const LightsRoute = LightsRouteImport.update({
  id: '/lights',
  path: '/lights',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const CameraRoute = CameraRouteImport.update({
  id: '/$camera',
  path: '/$camera',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$camera': typeof CameraRoute
  '/events': typeof EventsRoute
  '/lights': typeof LightsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$camera': typeof CameraRoute
  '/events': typeof EventsRoute
  '/lights': typeof LightsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$camera': typeof CameraRoute
  '/events': typeof EventsRoute
  '/lights': typeof LightsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$camera' | '/events' | '/lights'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/$camera' | '/events' | '/lights'
  id: '__root__' | '/' | '/$camera' | '/events' | '/lights'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CameraRoute: typeof CameraRoute
  EventsRoute: typeof EventsRoute
  LightsRoute: typeof LightsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/lights': {
      id: '/lights'
      path: '/lights'
      fullPath: '/lights'
      preLoaderRoute: typeof LightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$camera': {
      id: '/$camera'
      path: '/$camera'
      fullPath: '/$camera'
      preLoaderRoute: typeof CameraRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CameraRoute: CameraRoute,
  EventsRoute: EventsRoute,
  LightsRoute: LightsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
